<template>

<core-panel>

	<template v-slot:head>

		<h1>Timeline</h1>

		<p>Full history of <b>{{ timeline.length }}</b> events with this game.</p>

	</template>

	<template v-slot:body>

		<div class="event" v-for="(event, index) in timeline" :key="index" :data-type="event.type">

			<div class="event-dot"></div>

			<div class="event-content">

				<core-date :date="event.date" size="small" v-if="event.date" />

				<span class="event-detail">{{ formatEvent(event) }}</span>

			</div>

		</div>

	</template>

</core-panel>

</template>

<script>

import Panel from './../../common/Panel'

export default {

	mixins: [Panel],

	data: function() {

		return {
			detail: 'history',
			timeline: []
		}

	},

	methods: {

		response: function(json) {

			this.timeline = json.history

		},

		formatEvent: function(event) {

			if (event.type === 'play') {

				var count = event.detail && event.detail.count ? event.detail.count : 1
				return 'Played ' + count + (count === 1 ? ' time' : ' times')

			} else if (event.type === 'rating') {

				var detail = event.detail || {}
				if (detail.previous) return 'Rating changed from ' + detail.previous + ' to ' + detail.rating
				return 'Rated ' + detail.rating

			} else if (event.type === 'collection') {

				if (event.context === 1) return 'Added to collection'
				if (event.context === 2) return 'Collection updated'
				if (event.context === 3) return 'Removed from collection'
				return 'Collection change'

			} else if (event.type === 'status') {

				return 'Status changed'

			}

			return 'Event'

		}

	}

}

</script>

<style scoped>

.event {
	display: flex;
	align-items: center;
	gap: 12px;
	padding: 8px 16px;
	border-bottom: 1px solid rgba(var(--theme-color), 0.05);
}

.event-dot {
	width: 10px;
	height: 10px;
	border-radius: 50%;
	flex-shrink: 0;
	background: rgba(var(--theme-color), 0.2);
}

.event[data-type="play"] .event-dot {
	background: rgb(var(--theme-blue));
}

.event[data-type="rating"] .event-dot {
	background: rgb(var(--theme-yellow));
}

.event[data-type="collection"] .event-dot {
	background: rgb(var(--theme-green));
}

.event-content {
	display: flex;
	align-items: center;
	gap: 8px;
}

.event-detail {
	font-size: 13px;
	color: rgba(var(--theme-color), 0.7);
}

</style>
